import { customAxios } from '../../common/customAxios';

export const patchUserFlarelaneTags = (): Promise<void> => {
  return customAxios.patch('/users/flarelane');
};
